<script>
const authorize = function (name) {
  let state = name
  if (!state) {
    // 通过回调使用path = decodeURIComponent(state)
    // 通过path使用router.replace(path)
    state = window.location.hash
  }
  let origin = 'https://static.shecarefertility.com'
  let pathname = process.env.VUE_APP_MODE === 'development' ? '/shecare/test/webview/' : '/shecare/webview/'
  let REDIRECT_URI = origin + pathname + '#/wechat'
  // 微信服务号配置
  // 订阅号未认证  服务号处理服务
  let APPID = 'wx5d30d074a527ca12'
  // process.env.NODE_ENV === 'development'
  //   ? 'wxd26135b05c5c5a01'
  //   : 'wx5d30d074a527ca12'
  let url = 'https://open.weixin.qq.com/connect/oauth2/authorize?' +
    'appid=' + APPID + '&' +
    'redirect_uri=' + encodeURIComponent(REDIRECT_URI) + '&' +
    'response_type=code&' +
    'scope=snsapi_userinfo&' +
    'state=' + encodeURIComponent(state) + '#wechat_redirect'

  window.open(url, '_self')
}

export default {
  authorize: authorize
}
</script>